  <template>
  <div class="custom-actions">
    <button class="button is-primary" v-bind:class="{ 'is-loading': isLoading }" @click="itemAction('edit', rowData, rowIndex)">
      <span class="icon is-small">
        <i class="fa fa-edit"></i>
      </span>
    </button>
    <button class="button is-danger" v-bind:class="{ 'is-loading': isLoading }" @click="itemAction('delete', rowData, rowIndex)">
      <span class="icon is-small">
        <i class="fa fa-times"></i>
      </span>
    </button>
  </div>
</template>

<script>
import axios from 'axios'
import url from '../utils/url'
export default {
  data() {
    return {
      isLoading: false,
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction(action, data, index) {
      const self = this
      switch (action) {
        case 'delete':
          self.isLoading = true
          axios({
            url: `support/users/${data._id}`,
            headers: {
              authorization: window.localStorage.getItem('biyadmin')
            },
            baseURL: url,
            method: 'delete'
          })
            .then(function(result) {
              self.isLoading = false
              self.$toasted.success('done')
            })
            .catch(function(error) {
              self.isLoading = false
              const message = error.response.data.message ? error.response.data.message : 'There was an error'
              self.$toasted.error('error')
            })
          break
        case 'edit':
          console.log('Later tinz')
      }
    }
  }
}
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}

.custom-actions button.ui.button>i.icon {
  margin: auto !important;
}
</style>


// WEBPACK FOOTER //
// UserActions.vue?38415d4d